export const rollTypes = {
  minorInjury: "minorInjury",
  majorInjury: "majorInjury",
  insanity: "insanity",
};
